<template>
  <div class="ReviceSetting">
    <enfold>
      <div class="content">
        <div class="top">
          <div class="title">
            <div>{{ $t('terminal.group') }}</div>
            <div class="title-icon">
              <div class="title-control">
                <span style="margin-right: 5px;">{{ $t('router.checkMaterial') }}</span>
                <!-- <img @click="clearAll('material')" class="icon" src="@/assets/images/public/public_delete.png" /> -->
                <popovers :content="$t('cspm7')">
                  <img @click="clearAll('material')" class="icon" src="@/assets/images/public/public_delete.png" />
                </popovers>
              </div>
            </div>
            <div class="title-icon">
              <div class="title-control">
                <span style="margin-right: 5px;">{{ $t('router.checkProgramme') }}</span>
                <!-- <img @click="clearAll('play')" class="icon" src="@/assets/images/public/public_delete.png" /> -->
                <popovers :content="$t('cspm7')">
                  <img @click="clearAll('play')" class="icon" src="@/assets/images/public/public_delete.png" />
                </popovers>
              </div>
            </div>
            <div class="title-icon">
              <div class="title-control">
                <span style="margin-right: 5px;">{{ $t('router.checkPublish') }}</span>
                <!-- <img @click="clearAll('publish')" class="icon" src="@/assets/images/public/public_delete.png" /> -->
                <popovers :content="$t('cspm7')">
                  <img @click="clearAll('publish')" class="icon" src="@/assets/images/public/public_delete.png" />
                </popovers>
                <!-- <el-checkbox v-model="checked" style="margin-left: 10px;" @change="checkInterCut">
									<span>允许插播审核</span>
								</el-checkbox> -->
              </div>
            </div>
          </div>
        </div>
        <div class="main">
          <el-tree :data="tree_show_data" :props="defaultProps" default-expand-all v-loading="tree_loading">
            <!-- <span class="custom-tree-node" slot-scope="{ node, data }"> -->
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <div class="custom-tree-node-item">
                <!-- 素材审核 -->
                <div class="edit-item">
                  <div class="names" :class="{ namesCenter: data.material.user_name.length == 0 }">
                    <template v-if="data.material.user_name.length == 0">
                      <!-- <i>
												<img @click.stop="addCheck(data,'material')" class="icon"
													src="@/assets/images/public/public_add.png" />
											</i> -->
                      <el-button type="primary" round size="mini" icon="el-icon-plus"
                        @click.stop="addCheck(data, 'material')">{{ $t('nsrs01') }}</el-button>
                    </template>
                    <template v-else>
                      <el-popover placement="top-start" trigger="hover"
                        :content="`${data.material.user_name.toString()}`">
                        <span @click.stop="" slot="reference" class="user-name">{{
                          `${data.material.user_name.toString()}` }}</span>
                      </el-popover>
                    </template>
                  </div>
                  <template>
                    <div class="control flex-a-c" v-if="data.material.user_name.length != 0">
                      <!-- <template>
                        <i>
                          <img @click.stop="editSetting(data, 'material')" class="icon"
                            src="@/assets/images/public/public_edit.png" />
                        </i>
                        <i>
                          <img @click.stop="deleteAuditor(data, 'material')" class="icon"
                            src="@/assets/images/public/public_delete.png" />
                        </i>
                      </template> -->
                      <popovers :content="$t('cspm5')">
                        <img @click.stop="editSetting(data, 'material')" class="icon"
                          src="@/assets/images/public/public_edit.png" />
                      </popovers>
                      <popovers :content="$t('cspm7')">
                        <img @click.stop="deleteAuditor(data, 'material')" class="icon"
                          src="@/assets/images/public/public_delete.png" />
                      </popovers>
                    </div>
                  </template>
                </div>
                <!-- 节目审核 -->
                <div class="edit-item">
                  <div class="names" :class="{ namesCenter: data.play.user_name.length == 0 }">
                    <template v-if="data.play.user_name.length == 0">
                      <!-- <i>
												<img @click.stop="addCheck(data,'play')" class="icon"
													src="@/assets/images/public/public_add.png" />
											</i> -->
                      <el-button type="primary" round size="mini" icon="el-icon-plus"
                        @click.stop="addCheck(data, 'play')">{{ $t('nsrs01') }}</el-button>
                    </template>
                    <template v-else>
                      <el-popover placement="top-start" trigger="hover" :content="`${data.play.user_name.toString()}`">
                        <span @click.stop="" slot="reference" class="user-name">{{ `${data.play.user_name.toString()}`
                        }}</span>
                      </el-popover>
                    </template>
                  </div>
                  <template>
                    <div class="control flex-a-c" v-if="data.play.user_name.length != 0">
                      <!-- <template>
                        <i>
                          <img @click.stop="editSetting(data, 'play')" class="icon"
                            src="@/assets/images/public/public_edit.png" />
                        </i>
                        <i>
                          <img @click.stop="deleteAuditor(data, 'play')" class="icon"
                            src="@/assets/images/public/public_delete.png" />
                        </i>
                      </template> -->
                      <popovers :content="$t('cspm5')">
                        <img @click.stop="editSetting(data, 'play')" class="icon"
                          src="@/assets/images/public/public_edit.png" />
                      </popovers>
                      <popovers :content="$t('cspm7')">
                        <img @click.stop="deleteAuditor(data, 'play')" class="icon"
                          src="@/assets/images/public/public_delete.png" />
                      </popovers>

                    </div>
                  </template>
                </div>
                <!-- 节目审核 -->
                <div class="edit-item">
                  <div class="names" :class="{ namesCenter: data.publish.user_name.length == 0 }">
                    <template v-if="data.publish.user_name.length == 0">
                      <!-- <i>
												<img @click.stop="addCheck(data,'publish')" class="icon"
													src="@/assets/images/public/public_add.png" />
											</i> -->
                      <el-button type="primary" round size="mini" icon="el-icon-plus"
                        @click.stop="addCheck(data, 'publish')">{{ $t('nsrs01') }}</el-button>
                    </template>
                    <template v-else>
                      <el-popover placement="top-start" trigger="hover"
                        :content="`${data.publish.user_name.toString()}`">
                        <span @click.stop="" slot="reference" class="user-name">{{
                          `${data.publish.user_name.toString()}` }}</span>
                      </el-popover>
                    </template>
                  </div>
                  <template>
                    <div class="control flex-a-c" v-if="data.publish.user_name.length != 0">
                      <popovers :content="$t('cspm5')">
                        <img @click.stop="editSetting(data, 'publish')" class="icon"
                          src="@/assets/images/public/public_edit.png" />
                      </popovers>
                      <popovers :content="$t('cspm7')">
                        <img @click.stop="deleteAuditor(data, 'publish')" class="icon"
                          src="@/assets/images/public/public_delete.png" />
                      </popovers>
                      <!-- <template>
                        
                        <i>
                          <img @click.stop="editSetting(data, 'publish')" class="icon"
                            src="@/assets/images/public/public_edit.png" />
                        </i>

                        <i>
                          <img @click.stop="deleteAuditor(data, 'publish')" class="icon"
                            src="@/assets/images/public/public_delete.png" />
                        </i>
                      </template> -->
                    </div>
                  </template>
                </div>

              </div>
            </span>
          </el-tree>
        </div>
      </div>
    </enfold>
    <del-dialog :title="$t('schedule.tips')" :dialogVisible="clearDialogVisible" @closeDialog="ClearCloseDialog">
      <div style="width: 100%;height: 80px;line-height: 80px; text-align: center;">
        {{ $t('system.clearTips1') }}
      </div>
    </del-dialog>
    <del-dialog :title="$t('schedule.tips')" :dialogVisible="deleteDialogVisible" @closeDialog="deleteCloseDialog">
      <div style="width: 100%;height: 80px;line-height: 80px; text-align: center;">
        {{ $t('system.clearTips2') }}
      </div>
    </del-dialog>
    <form-dialog-confirm :title="$t('system.selectReviewer')" :dialogVisible="formDialogVisible"
      @closeDialog="formCloseDialog" dWidth="500px">
      <div class="form-main">
        <div class="content">
          <template v-if="this.plan_checks_list.length == 0">
            <div class="noCheeck"><span style="margin-right: 10px;">{{ $t('system.noReviers') }}</span>
              <el-link type="primary" @click="createCheckUser">{{ $t('system.createTips') }}</el-link>
            </div>
          </template>
          <div class="items" v-for="(item, index) in this.plan_checks_list" :key="index">
            <el-checkbox v-model="item.isChecked" @change="update"></el-checkbox>
            <div>{{ item.name }}</div>
          </div>
        </div>
        <div class="checkbox">
          <el-checkbox v-model="isUseSameAuditor">{{ $t('system.sameReviwers') }}</el-checkbox>
        </div>
        <div class="button">
          <el-button round @click='formCancel'>{{ $t('terminal.cancel') }}</el-button>
          <el-button type="primary" round @click='formConfirm'>{{ $t('terminal.confirm') }}</el-button>
        </div>
      </div>
    </form-dialog-confirm>
  </div>
</template>

<script>
import {
  getFatherIds,
  getChildrenGroupIds
} from "@/assets/scripts/publicFunction";
import {
  setGroupInfo,
  setFirst
} from "@/assets/scripts/reviewSetting";
import Enfold from "@/components/basics/Enfold";
import DelDialog from "@/components/basics/DelDialog";
import FormDialogConfirm from "@/components/basics/FormDialogConfirm";
import Popovers from "@/components/basics/Popover";

export default {
  name: "ReviewSetting",
  components: {
    Enfold,
    DelDialog,
    FormDialogConfirm,
    Popovers
  },
  data() {
    return {
      groupList: [],
      plan_checks_list: [],
      plan_selected_check_list: [], //选择的人员
      children_group_ids: [],
      fagroup_ids: [],
      tree_data: [],
      tree_show_data: [],
      infoList: [],
      defaultProps: {
        children: "child",
        label: "name",
      },
      currentDelete: {},
      faterGroup: {},

      currentType: 0,

      current_set_type: '',
      clear_all_type: '',

      isMaterialCheck: true,
      checked: false,
      isUseSameAuditor: false,
      tree_loading: false,

      clearDialogVisible: false,
      formDialogVisible: false,
      deleteDialogVisible: false
    }
  },
  methods: {
    createCheckUser() {
      this.$router.push({
        name: 'UserManage',
      })
    },
    checkInterCut() {
      if (this.checked) {
        this.$http.post('/admin/check/checkInterCut', {
          check_inter_cut: 1
        })
      } else {
        this.$http.post('/admin/check/checkInterCut', {
          check_inter_cut: 0
        })
      }
    },
    deleteAuditor(data, type) {
      this.currentDelete = data;
      this.currentType = type;
      this.deleteDialogVisible = true;
    },
    async deleteCloseDialog(isConfirm) {
      if (isConfirm) {
        await this.$http.post('/admin/check/clear', {
          group_ids: this.currentDelete.id,
          check_type: this.currentType
        }, () => {
          setTimeout(() => {
            this.$router.go(0);
          }, 500);
        });
        await this.updateTreeData();
      }
      this.deleteDialogVisible = false;
    },
    clearAll(data) {
      this.clear_all_type = data;
      this.clearDialogVisible = true;
    },
    async ClearCloseDialog(isConfirm) {
      if (isConfirm) {
        await this.$http.post('/admin/check/clear', {
          group_ids: sessionStorage.getItem('group_ids'),
          check_type: this.clear_all_type
        }, () => {
          setTimeout(() => {
            this.$router.go(0);
          }, 500);
        })
        await this.updateTreeData();
      }

      this.clearDialogVisible = false;
    },
    addCheck(data, type) {
      //const group_ids = sessionStorage.getItem('group_ids');
      this.current_set_type = type;
      this.current_group = data;
      this.formDialogVisible = true;

      let current_pid = data.pid;
      let idsArray = getFatherIds(this.groupList, current_pid, [data]);
      let ids = [];
      idsArray.forEach((ele) => {
        ids.push(ele.id)
      })
      ids = ids.toString();
      this.$http.post('/admin/check/userList', {
        group_ids: ids,
      }, data => {
        this.plan_checks_list = data;
        this.plan_checks_list.forEach((ele) => {
          ele.isChecked = false;
        })
        //console.log(this.plan_checks_list);
      })


    },
    editSetting(data, type) {
      this.current_set_type = type;
      this.current_group = data;
      this.formDialogVisible = true;

      let current_pid = data.pid;
      let idsArray = getFatherIds(this.groupList, current_pid, [data]);
      let ids = [];
      idsArray.forEach((ele) => {
        ids.push(ele.id)
      })
      ids = ids.toString();
      this.$http.post('/admin/check/userList', {
        group_ids: ids,
      }, info => {
        this.plan_checks_list = info;

        //console.log('要编辑的审核成员..', data);
        if (type == "material") {
          this.plan_checks_list.forEach((ele) => {
            let flag = false;
            for (let i = 0; i < data.material.user_ids.length; i++) {
              if (data.material.user_ids[i] == ele.id) {
                flag = true;
                break;
              }
            }
            if (flag) {
              ele.isChecked = true;
            } else {
              ele.isChecked = false;
            }
          })
        } else if (type == "play") {
          this.plan_checks_list.forEach((ele) => {
            let flag = false;
            for (let i = 0; i < data.play.user_ids.length; i++) {
              if (data.play.user_ids[i] == ele.id) {
                flag = true;
                break;
              }
            }
            if (flag) {
              ele.isChecked = true;
            } else {
              ele.isChecked = false;
            }
          })
        } else if (type == "publish") {
          this.plan_checks_list.forEach((ele) => {
            let flag = false;
            for (let i = 0; i < data.publish.user_ids.length; i++) {
              if (data.publish.user_ids[i] == ele.id) {
                flag = true;
                break;
              }
            }
            if (flag) {
              ele.isChecked = true;
            } else {
              ele.isChecked = false;
            }
          })
        }

        this.$forceUpdate();
        //console.log('审核成员列表', this.plan_checks_list);
        //console.log(this.plan_checks_list);
      })
    },
    findFather(array, current_pid) {
      for (let i = 0; i < array.length; i++) {
        if (array[i].id == current_pid) {
          this.faterGroup = array[i];
          break;
        }
        if (array[i].child.length != 0) {
          this.findFather(array[i].child, current_pid);
        }
      }
      //console.log('父节点...', this.faterGroup)
    },
    update() {
      this.$forceUpdate();
    },
    formCloseDialog() {
      this.formDialogVisible = false;
    },
    formCancel() {
      this.formDialogVisible = false;
      this.isUseSameAuditor = false;
    },
    async formConfirm() {
      let user_ids = [];
      this.plan_checks_list.forEach((ele) => {
        if (ele.isChecked) {
          this.plan_selected_check_list.push(ele);
          user_ids.push(ele.id)
        }
      })
      //console.log("选择的审核人员是...", user_ids.toString());
      if (this.isUseSameAuditor) {
        let group_ids = getChildrenGroupIds([this.current_group], []);
        await this.$http.post('/admin/check/set', {
          group_ids,
          user_ids: user_ids.toString(),
          check_type: this.current_set_type
        }, () => {
          setTimeout(() => {
            this.$router.go(0);
          }, 500);
        })
      } else {
        await this.$http.post('/admin/check/set', {
          group_ids: this.current_group.id,
          user_ids: user_ids.toString(),
          check_type: this.current_set_type
        }, () => {
          setTimeout(() => {
            this.$router.go(0);
          }, 500);
        })
      }

      await this.updateTreeData();

      //console.log('当前选择的节点是...', this.current_group);
      //console.log(this.plan_selected_check_list);
      this.formDialogVisible = false;
      this.isUseSameAuditor = false;
    },
    setCheckListInfo() {
      //let groupList = [];
      this.infoList.forEach((ele) => {
        this.tree_data = setGroupInfo(this.groupList, ele);
      })
      this.tree_show_data = this.infoList.length == 0 ? this.groupList : this.tree_data;
      //console.log('设置后...', this.tree_data);
      this.$forceUpdate();
      this.tree_loading = false;
    },
    async updateTreeData() {
      this.tree_loading = true;
      const group_ids = sessionStorage.getItem('group_ids');
      await this.$http.post("/admin/access/groupList", {}, data => {
        this.groupList = data;
        setFirst(this.groupList);
      });
      await this.$http.post('/admin/check/checkSettings', {
        group_ids: group_ids
      }, data => {
        this.infoList = data.checkList;
      })

      this.setCheckListInfo();

    }
  },
  async created() {
    const group_ids = sessionStorage.getItem('group_ids');
    await this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
      setFirst(this.groupList);
    });
    await this.$http.post('/admin/check/checkSettings', {
      group_ids: group_ids
    }, data => {
      this.infoList = data.checkList;
      this.checked = data.checkInterCut == 1 ? true : false;
    })

    this.setCheckListInfo();
    this.update();
  }

}
</script>

<style lang="scss" scoped>
.ReviceSetting {
  width: 100%;
  height: 100%;

  .content {
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .items {
      display: flex;
      align-items: center;
      padding-left: 10px;
      width: 100%;
      height: 30px;
      font-size: 16px;

      div {
        height: 30px;
        width: 100%;
        padding-left: 10px;
        line-height: 30px;
      }
    }

    .items:hover {
      background-color: #e5f9fd;
    }

    .top {
      width: 100%;
      height: 52px;
      color: var(--theme-color-customized-1);
      font-size: 16px;
      border-bottom: 2px solid #d7ecf3;

      .title {
        width: 95%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        div {
          text-align: center;
          width: 25%;
        }

        .title-icon {
          display: flex;
          flex-direction: column;
          align-items: center;

          .title-control {
            white-space: nowrap;
            display: flex;
            align-items: center;
          }

          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }

    .main {
      width: 100%;
      height: calc(100% - 80px);
      overflow: auto;

      .items {
        width: 95%;
        height: 60px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        div {
          flex-basis: 25%;
        }
      }

      .custom-tree-node {
        width: 100%;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;

        .custom-tree-node-item {
          width: 72vw;
          min-width: 720px;
          margin-right: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .edit-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 32px;

            .names {
              width: calc(100% - 80px);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              height: 32px;
              line-height: 32px;

              .user-name {
                line-height: 32px;
                font-size: 16px;
              }
            }

            .namesCenter {
              width: 100%;
            }

            .control {
              width: 80px;
              margin-right: 30px;

              img {
                width: 32px;
                height: 32px;
              }

              i {
                width: 32px;
                height: 32px;

                img {
                  width: 32px;
                  height: 32px;
                }
              }
            }

            i {
              width: 32px;
              height: 32px;

              img {
                width: 32px;
                height: 32px;
              }
            }
          }
        }

        div {
          text-align: center;
          width: 33%;
        }
      }

      /deep/ .el-tree-node__content {
        border-bottom: 1px dashed #d9d9d9;
        height: 40px;
      }
    }
  }

  .form-main {
    height: 300px;
    width: 100%;

    display: flex;
    align-items: center;
    flex-direction: column;

    .content {
      // height: 200px;
      flex: 1;
      border: 1px solid #c5c9d2;
      position: relative;

      .noCheeck {
        position: absolute;
        white-space: nowrap;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
      }
    }

    .checkbox {
      height: 50px;
      width: 100%;
      padding-top: 10px;
      padding-left: 5px;
    }

    .button {
      height: 50px;
      width: 200px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>
